import { Link } from 'react-router-dom';
import aboutImg from 'materials/img/about.png';
import { useRevealGroup } from 'hooks/useReveal';
import './About.css';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Блок «Про нас» на головній — ADR-0006.
 *
 * Було: сухий текстовий блок без жодного зображення — заголовок, лінійка,
 * абзац, посилання. Стало: фото зі змагань у легкій рамці з роками
 * діяльності на розі (цифра взята з тексту нижче, а не вигадана) плюс
 * посилення типографіки та кнопка-стрілка кружечком, як у соцмереж на
 * сторінці контактів.
 *
 * Прибрано обертові кільця (SVG textPath «Про нас Про нас Про нас…» на 15 с
 * і рамка на 25 с у зворотний бік) та GSAP-виїзд збоку. Кінематографічний
 * рівень видовищності сторінки /about (ADR-0011) тут навмисно не повторюємо —
 * це вітринний тизер, а не авторська сторінка.
 */
const ABOUT_TEXT = {
  ua: [
    `СГОСТУ — одна з наймасовіших всеукраїнських громадських організацій у сфері спортивних танців
     України. Ми працюємо понад 25 років та об’єднуємо танцювальні клуби, спортсменів, тренерів і
     суддів у більшості регіонів країни.`,
    `Ми поєднуємо багаторічний досвід із сучасним підходом до розвитку спортивного танцю. Наші
     пріоритети — цифровізація та автоматизація процесів, командна робота, прозорість і створення
     нових можливостей для кожного учасника танцювального спорту.`,
    `Ми є частиною великого танцювального світу та щодня працюємо над тим, щоб зробити його
     сучаснішим, відкритішим і кращим.`,
  ],
  en: [
    `SGOSTU is one of the largest nationwide public organizations in the field of sports dance in
     Ukraine. We have been working for more than 25 years, uniting dance clubs, athletes, coaches
     and judges in most regions of the country.`,
    `We combine years of experience with a modern approach to the development of sports dance. Our
     priorities are digitalization and process automation, teamwork, transparency, and creating new
     opportunities for every participant in dance sport.`,
    `We are part of the greater dance world, and every day we work to make it more modern, more
     open, and better.`,
  ],
};

export default function About() {
  const language = useLanguage();
  const groupRef = useRevealGroup('.about-reveal-item', { step: 90 });

  return (
    <section className='about section'>
      <div className='container about-wrapper' ref={groupRef}>
        <div className='about-reveal-item about-media'>
          <div className='about-frame'>
            <img className='about-photo' src={aboutImg} alt='' />
          </div>
          <div className='about-stat'>
            <span className='about-stat-value tnum'>25+</span>
            <span className='about-stat-label'>{language === 'en' ? 'years of activity' : 'років діяльності'}</span>
          </div>
        </div>

        <div className='about-reveal-item about-body'>
          <span className='section-label'>{language === 'en' ? 'Who we are' : 'Хто ми'}</span>
          <h2 className='about-heading'>{language === 'en' ? 'SGOSTU' : 'СГОСТУ'}</h2>
          <span className='about-rule' aria-hidden='true' />

          {(language === 'en' ? ABOUT_TEXT.en : ABOUT_TEXT.ua).map((paragraph) => (
            <p className='about-text' key={paragraph}>
              {paragraph}
            </p>
          ))}

          <Link className='about-link' to='/about'>
            <span>{language === 'en' ? 'History of the organization' : 'Історія організації'}</span>
            <span className='about-link-arrow' aria-hidden='true'>
              <svg width='16' height='16' viewBox='0 0 24 24'>
                <path
                  d='M5 12h14M13 6l6 6-6 6'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='1.6'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
